<template>
  <section v-lenis-scroll class="collection-sec">
    <div class="home">
      <div class="filter_responsive">
        <div class="filter_cta_wrapper">
          <button id="filterCta" class="filter_cta" aria-label="Filter" @click="myFilter">
            {{ shopifyData.applyFilterCta }}
          </button>
          <button id="sortCta" class="filter_cta" aria-label="Sort" @click="sortBy">
            {{ shopifyData.sortByDropdownTextResponsive }}
          </button>
        </div>
      </div>
      <div class="filter_row">
        <div class="row_inner">
          <div class="apply_filter_cta_wrapper">
            <button
              class="apply_filter_cta"
              disabled
              aria-label="Apply Filter"
              @click="applyfilter"
            >
              {{ shopifyData.applyFilterCta }}
            </button>
          </div>
          <div class="filters">
            <div class="filters_inner_row">
              <div class="filters_responsive">
                <div class="close-btn" aria-label="Close Menu" @click="closeMenu">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8861 11.8864L35.6587 35.6589"
                      stroke="#656565"
                      stroke-width="1.5"
                    />
                    <path d="M11.8861 35.6586L35.6587 11.886" stroke="#656565" stroke-width="1.5" />
                  </svg>
                </div>
                <div class="filter_cta_wrapper">
                  <button class="filter_cta filter-modifier" aria-label="Filter">
                    {{ shopifyData.filterinnerResponsive }}
                  </button>
                  <button
                    class="filter_cta clear-modifier"
                    :class="{ activeClear: showClearAll }"
                    aria-label="Clear Filters"
                    @click="clearAllFilter()"
                  >
                    CLEAR FILTERS
                    <svg
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-v-bb57343a=""
                    >
                      <path d="M0.5 1L5 5.5L2.75 3.25L0.5 1Z" stroke="white" data-v-bb57343a="" />
                      <path d="M5 1L0.5 5.5L2.75 3.25L5 1Z" stroke="white" data-v-bb57343a="" />
                    </svg>
                  </button>
                </div>
              </div>
              <div class="filters_inner">
                <!-- Categories filter -->
                <div
                  class="filter"
                  aria-label="Categories Filter"
                  @mouseenter="isMobile == true ? null : (show = true)"
                  @mouseleave="isMobile == true ? null : (show = false)"
                  @click="isMobile == false ? null : closeDropDown(show, 'show')"
                >
                  <!-- v-on:mouseover="show = !show" -->
                  <div
                    class="dropdown"
                    aria-label="Dropdown"
                    @click="
                      (event) => {
                        addActive(event);
                      }
                    "
                  >
                    <div class="overselect">
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L9 1"
                          stroke="black"
                          stroke-width="0.75"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <button class="c-form-input" aria-label="Categories">Categories</button>
                  </div>
                  <div class="multiselect" :class="{ active: show }">
                    <div class="tmb_header_dopdown">
                      <ul>
                        <li v-for="option in ddTestCategory" :key="option.id">
                          <input
                            :id="option.id"
                            class="multiselectOption"
                            type="checkbox"
                            name="category"
                            :value="option.value"
                            aria-label="Category"
                            @change="onCheck($event)"
                          />
                          <label class="optionLabel" :for="option.id">{{
                            option.text.toLowerCase()
                          }}</label>
                        </li>
                      </ul>
                      <div class="btn_wrapper">
                        <!-- <button class="filterBtn modifier" @click="filterProduct">Apply</button> -->
                        <button
                          class="filterBtn"
                          aria-label="Clear"
                          @click="clearCheckBoxs('category')"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- color filter -->
                <div
                  class="filter color-filter"
                  aria-label="Color Filter"
                  @mouseenter="isMobile == true ? null : (showColor = true)"
                  @mouseleave="isMobile == true ? null : (showColor = false)"
                  @click="isMobile == false ? null : closeDropDown(showColor, 'showColor')"
                >
                  <div
                    class="dropdown"
                    aria-label="Dropdown"
                    @click="
                      (event) => {
                        addActive(event);
                      }
                    "
                  >
                    <div class="overselect">
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L9 1"
                          stroke="black"
                          stroke-width="0.75"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <button class="c-form-input" aria-label="Color">Color</button>
                  </div>
                  <div class="multiselect" :class="{ active: showColor }">
                    <div class="tmb_header_dopdown">
                      <ul>
                        <li v-for="option in ddTestColor" :key="option.id">
                          <input
                            :id="option.id"
                            class="multiselectOption"
                            type="checkbox"
                            name="color"
                            :value="option.value"
                            aria-label="Color"
                            @change="onCheckColor($event)"
                          />
                          <label class="optionLabel" :for="option.id">{{
                            option.text.toLowerCase()
                          }}</label>
                        </li>
                      </ul>
                      <div class="btn_wrapper">
                        <!-- <button class="filterBtn modifier" @click="filterProductByColor">Apply</button> -->
                        <button
                          class="filterBtn"
                          aria-label="Clear"
                          @click="clearCheckBoxs('color')"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- size filter -->
                <div
                  class="filter size-filter"
                  aria-label="Size Filter"
                  @mouseenter="isMobile == true ? null : (showSize = true)"
                  @mouseleave="isMobile == true ? null : (showSize = false)"
                  @click="isMobile == false ? null : closeDropDown(showSize, 'showSize')"
                >
                  <div
                    class="dropdown"
                    aria-label="Dropdown"
                    @click="
                      (event) => {
                        addActive(event);
                      }
                    "
                  >
                    <div class="overselect">
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L9 1"
                          stroke="black"
                          stroke-width="0.75"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <button class="c-form-input" aria-label="Size">Size</button>
                  </div>
                  <div class="multiselect" :class="{ active: showSize }">
                    <div class="tmb_header_dopdown">
                      <ul>
                        <li v-for="option in ddTestSize" :key="option.id">
                          <input
                            :id="option.id"
                            class="multiselectOption"
                            type="checkbox"
                            name="size"
                            :value="option.value"
                            aria-label="Size"
                            @change="onCheckSize($event)"
                          />
                          <label class="optionLabel" :for="option.id">{{
                            option.text.toLowerCase()
                          }}</label>
                        </li>
                      </ul>
                      <div class="btn_wrapper">
                        <!-- <button class="filterBtn modifier" @click="filterProductBySize">Apply</button> -->
                        <button
                          class="filterBtn"
                          aria-label="Clear"
                          @click="clearCheckBoxs('size')"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- material filter -->
                <div
                  class="filter filter-modifier"
                  aria-label="Material Filter"
                  @mouseenter="isMobile == true ? null : (showMaterial = true)"
                  @mouseleave="isMobile == true ? null : (showMaterial = false)"
                  @click="isMobile == false ? null : closeDropDown(showMaterial, 'showMaterial')"
                >
                  <div
                    class="dropdown"
                    aria-label="Dropdown"
                    @click="
                      (event) => {
                        addActive(event);
                      }
                    "
                  >
                    <div class="overselect">
                      <svg
                        width="10"
                        height="6"
                        viewBox="0 0 10 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L9 1"
                          stroke="black"
                          stroke-width="0.75"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <button class="c-form-input" aria-label="Material">Material</button>
                  </div>
                  <div class="multiselect" :class="{ active: showMaterial }">
                    <div class="tmb_header_dopdown">
                      <ul>
                        <li v-for="option in ddTestMaterial" :key="option.id">
                          <input
                            :id="option.id"
                            class="multiselectOption"
                            type="checkbox"
                            name="material"
                            :value="option.value"
                            aria-label="Material"
                            @change="onCheckMaterial($event)"
                          />
                          <label class="optionLabel" :for="option.id">{{
                            option.text.toLowerCase()
                          }}</label>
                        </li>
                      </ul>
                      <div class="btn_wrapper">
                        <!-- <button class="filterBtn modifier" @click="filterProductByMaterial">Apply</button> -->
                        <button
                          class="filterBtn"
                          aria-label="Clear"
                          @click="clearCheckBoxs('material')"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Clear Filter -->
                <div class="filter">
                  <button
                    class="clearFilter"
                    :class="{ activeClear: showClearAll }"
                    aria-label="Clear Filters"
                    @click="clearAllFilter()"
                  >
                    Clear filters
                    <svg
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0.5 1L5 5.5L2.75 3.25L0.5 1Z" stroke="white" />
                      <path d="M5 1L0.5 5.5L2.75 3.25L5 1Z" stroke="white" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="sort_by">
            <div class="filters_responsive">
              <div class="close-btn" aria-label="Close Menu" @click="closeMenu">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11.8861 11.8864L35.6587 35.6589" stroke="#656565" stroke-width="1.5" />
                  <path d="M11.8861 35.6586L35.6587 11.886" stroke="#656565" stroke-width="1.5" />
                </svg>
              </div>
              <div class="filter_cta_wrapper">
                <button class="filter_cta filter-modifier" aria-label="Sort By">
                  {{ shopifyData.sortinnerResponsive }}
                </button>
              </div>
            </div>
            <div class="sort_by_inner">
              <div class="range">
                <label for="ageInputId" class="sr-only" aria-label="Grid Column Slider"
                  >Grid Column Slider</label
                >
                <div class="add_remove">
                  <button aria-label="Decrement" type="button">-</button>
                  <button aria-label="Increment" type="button">+</button>
                </div>
                <input
                  id="ageInputId"
                  type="range"
                  value="{{gridColumn}}"
                  min="2"
                  max="6"
                  step="2"
                  class="progress"
                  aria-label="Slider"
                  @input="sliderChange($event)"
                />
              </div>
              <div class="sortFilter" @mouseenter="showSort = true" @mouseleave="showSort = false">
                <button class="sortBtn" aria-label="Sort By">
                  Sort By
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      data-v-35171425=""
                      d="M1 1L5 5L9 1"
                      stroke="black"
                      stroke-width="0.75"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <div class="multiselect" :class="{ active: showSort }">
                  <div class="tmb_header_dopdown">
                    <ul>
                      <li v-for="option in ddTestSort" :key="option.id">
                        <input
                          :id="option.id"
                          class="multiselectOption"
                          type="checkbox"
                          name="sort"
                          :checked="option.id == 'sort1' ? true : false"
                          :value="option.value"
                          aria-label="Sort Option"
                          @change="onCheckSort($event)"
                        />
                        <label
                          class="optionLabel"
                          :for="option.id"
                          aria-label="Sort Option"
                          @click="
                            (event) => {
                              closeSortMenu(event);
                            }
                          "
                          >{{ option.text }}</label
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product_grid modify-slider">
        <div class="grid_inner" :class="{ grid_inner_max: gridMax, grid_inner_min: gridMin }">
          <div v-for="product in productList" :key="product.id" class="product_item">
            <div
              v-if="product.images.length > 0"
              class="card"
              @mouseenter="isMobile == false ? (productId = product.id) : ''"
              @mouseleave="cardmouseleave(product.id)"
            >
              <a :href="'/products/' + product.handle" aria-label="Product Link">
                <div
                  :id="'item_left_' + product.id"
                  class="item_left"
                  :class="{ item_left_active: product.id == productId }"
                  aria-label="Product Stock"
                >
                  {{
                    product.variants[0].stock <= 5 && product.variants[0].stock >= 1
                      ? 'ONLY ' + product.variants[0].stock + ' LEFT'
                      : product.variants[0].stock == 0
                        ? 'SOLD OUT'
                        : ''
                  }}
                </div>
                <div
                  :id="'product_img_wrapper' + product.id"
                  class="product_img_wrapper"
                  :class="{ out_of_stock: product.variants[0].stock == 0 }"
                  aria-label="Product Image"
                >
                  <img
                    v-if="product.variants[0].featured_image != null"
                    :id="product.id"
                    v-lazy="product.variants[0].featured_image.src"
                    :alt="product.variants[0].featured_image.alt || 'Product Image'"
                    loading="lazy"
                    aria-label="Featured Image"
                    width=""
                    height=""
                  />
                  <img
                    v-else
                    :id="product.id"
                    v-lazy="product.images[0].src"
                    :alt="product.images[0].alt || 'Product Image'"
                    loading="lazy"
                    aria-label="Placeholder Image"
                    width=""
                    height=""
                    @mouseenter="mouseover($event, product.images[product.images.length - 1].src)"
                    @mouseleave="mouseleave($event, product.images[0].src)"
                  />
                  <!-- <div class="out_of_stock_text" :id="'out_of_stock_text'+product.id" v-bind:class="{ out_of_stock_text_active: product.variants[0].stock == 0 }">SOLD OUT</div> -->
                </div>
                <h5 class="card-title" aria-label="Product Title">{{ product.title }}</h5>
                <h5 class="card-title bold" aria-label="Product Price">
                  ${{ Math.floor(product.variants[0].price) }}
                </h5>
              </a>
              <div
                class="quickButton"
                :class="{ quickActive: isMobile == false ? product.id == productId : true }"
                aria-label="Quick Button"
              >
                <div class="color_swatches">
                  <ul>
                    <li
                      v-for="color in product.options"
                      :key="color + index"
                      class="nav-dots"
                      aria-label="Color Swatch"
                    >
                      <span v-if="color.name.toLowerCase().includes('color')">
                        <template v-if="color.values.length <= 4">
                          <label
                            v-for="colors in color.values"
                            :id="'img-dot-' + product.id + colors"
                            :key="colors"
                            for="img-1"
                            class="nav-dot"
                            :style="inlineBgImage(colors)"
                            aria-label="Color Swatch"
                            @click="(e) => onSelectColor(colors, product, e)"
                          />
                        </template>
                        <template v-else>
                          <swiper
                            :modules="modules"
                            :slides-per-view="4"
                            :slides-per-slide="1"
                            navigation
                          >
                            <swiper-slide v-for="colors in color.values" :key="colors">
                              <label
                                :id="'img-dot-' + product.id + colors"
                                for="img-1"
                                class="nav-dot"
                                :style="inlineBgImage(colors)"
                                aria-label="Color Swatch"
                                @click="(e) => onSelectColor(colors, product, e)"
                              />
                            </swiper-slide>
                          </swiper>
                        </template>
                      </span>
                    </li>
                  </ul>
                </div>
                <div class="product_cta_wrapper">
                  <button
                    :id="'quickAdd' + product.id"
                    class="quickAdd"
                    :class="{ quickAdd_deactive: product.variants[0].stock == 0 }"
                    aria-label="Quick Add"
                    @click="addToCard(product)"
                  >
                    <span>Quick Add</span>
                    <div class="loder_tmb">
                      <span /><span /> <span /><span />
                      <span />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row centeralign addmargin"
          :class="{
            productnotfound: productList.length == 0,
            productfound: productList.length > 0,
          }"
          aria-label="No Matches Found"
        >
          <h2 class="sec_heading">We're sorry, no matches were found.</h2>
          <h4 class="body_text">
            We couldn't find any results for your selected filters. Clear your filters or contact
            our Client Services Team at clientservices@behno.com and we'll be happy to help.
          </h4>
        </div>
      </div>
    </div>
    <div class="big_container">
      <div class="ethics_in_fashion">
        <div class="ethics_content">
          <div class="ethics_content_inner">
            <h2 class="sec_heading">
              {{ shopifyData.secBottomheading }}
            </h2>
            <p class="body_text">
              {{ shopifyData.secBottomInfo }}
            </p>
          </div>
          <div class="fashion_img_grid">
            <template v-for="(item, index) in shopifyData.fashion_img" :key="index">
              <img
                v-lazy="item.imgUrl.src"
                :aria-placeholder="item.imgUrl.placeholder"
                :alt="item.imgUrl.alt"
                loading="lazy"
                aria-hidden="true"
                aria-label="Fashion Image"
                width=""
                height=""
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import products from '@/assets/json/collectionproduct.json';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper';
// import { constants } from 'buffer';
// import axios from 'axios'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Navigation],
    };
  },
  data() {
    return {
      isActive: false,
      isMobile: false,
      gridMax: false,
      gridMin: false,
      show: false,
      showSort: false,
      showColor: false,
      showSize: false,
      showMaterial: false,
      selected: [],
      selectedSort: ['Recommended'],
      selectedColor: [],
      selectedSize: [],
      selectedMaterial: [],
      ddTestCategory: this.getCategoryDropDownList(),
      ddTestColor: this.getColorDropDownList(),
      ddTestSize: this.getSizeDropDownList(),
      ddTestMaterial: this.getMaterialDropDownList(),
      productList: [], //this.array_chunk(products, 20),
      fullproductList: products,
      page_index: 0,
      page_size: 12,
      filterByCategory: [],
      filterByColor: [],
      filterBySize: [],
      filterByMaterial: [],
      busy: false,
      showClearAll: false,
      gridColumn: 4,
      productId: 0,
      ddTestSort: [
        {
          id: 'sort1',
          value: 'Recommended',
          text: 'Recommended',
        },
        {
          id: 'sort2',
          value: 'LowToHigh',
          text: 'Price: Low to High',
        },
        {
          id: 'sort3',
          value: 'HighToLow',
          text: 'Price: High to Low',
        },
        {
          id: 'sort4',
          value: 'Latest',
          text: 'Latest Arrivals',
        },
        {
          id: 'sort5',
          value: 'Discount',
          text: 'Percent Discount',
        },
      ],
      sortObject: {},
    };
  },
  mounted() {
    // document.addEventListener('click', this.onClick);

    window.addEventListener('pageshow', this.onPageShow);
    this.loadMore();
    this.setScreenRangeGrid();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    // if (window.innerWidth <= 767) {
    //   this.isMobile = true;
    // }
    // window.addEventListener('resize', function () {
    //   if (window.innerWidth <= 767) {
    //     this.isMobile = true;
    //   } else {
    //     this.isMobile = false;
    //   }
    // });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('pageshow', this.onPageShow);
  },
  methods: {
    closeSortMenu(event) {
      event.target.closest('.show').classList.remove('show');
    },

    addActive(event) {
      event.currentTarget.classList.toggle('active');
    },

    // onPageShow(event) {
    //   window.scrollTo(0, 0);
    // },

    handleResize() {
      this.isMobile = window.innerWidth <= 767;
    },

    closeDropDown(show, type) {
      if (type == 'show') {
        if (show == true) {
          this.show = false;
        } else {
          this.show = true;
        }
      }
      if (type == 'showColor') {
        if (show == true) {
          this.showColor = false;
        } else {
          this.showColor = true;
        }
      }
      if (type == 'showSize') {
        if (show == true) {
          this.showSize = false;
        } else {
          this.showSize = true;
        }
      }
      if (type == 'showMaterial') {
        if (show == true) {
          this.showMaterial = false;
        } else {
          this.showMaterial = true;
        }
      }
    },
    // open filter navbar
    myFilter() {
      const filters = document.querySelector('.filters');
      const applyfilters = document.querySelector('.apply_filter_cta_wrapper');
      applyfilters.classList.add('show');
      filters.classList.toggle('show');
    },

    // open sortBy navbar
    sortBy() {
      const sortBy = document.querySelector('.sort_by');
      sortBy.classList.toggle('show');
    },

    // close navbar
    closeMenu(e) {
      const activeMenu = e.currentTarget.closest('.show');
      activeMenu.classList.remove('show');
      const applyfilters = document.querySelector('.apply_filter_cta_wrapper');
      applyfilters.classList.remove('show');
    },

    // apply filter and close filter
    applyfilter() {
      const applyfilters = document.querySelector('.apply_filter_cta_wrapper.show');
      const applyfilterShow = document.querySelector('.filters.show');
      applyfilters.classList.remove('show');
      applyfilterShow.classList.remove('show');
    },

    cardmouseleave(id) {
      this.productId = 0;
      const quickAdd = document.querySelector('#quickAdd' + id);
      quickAdd.classList.remove('quickAdd_active');
    },

    inlineBgImage(colors) {
      const color = colors.toLowerCase().replace(/[^A-Z0-9]+/gi, '-');
      const bgImage =
        '//cdn.shopify.com/s/files/1/0899/2182/files/' + color + '.png?v=5251390435792914590';

      const url = `background-image:url(${bgImage});`;
      return url + 'background:' + color;
    },

    onSelectColor(color, product, event) {
      if (event.currentTarget.parentElement.children.length > 1) {
        const childcolor = event.currentTarget.parentElement.children;
        for (const item of childcolor) {
          item.classList.remove('activecolor');
        }
      }
      event.currentTarget.classList.add('activecolor');
      const img = document.getElementById(product.id);
      const div = document.querySelector('#item_left_' + product.id);
      const product_img_div = document.querySelector('#product_img_wrapper' + product.id);
      const out_of_stock_text = document.querySelector('#out_of_stock_text' + product.id);
      const quickAdd = document.querySelector('#quickAdd' + product.id);

      const varints = product.variants.filter((item) => {
        return item.title.includes(color);
      });
      if (varints.length > 0) {
        if (varints[0].featured_image != null) {
          img.src = varints[0].featured_image.src;
        }
        div.textContent = varints[0].stock <= 5 ? 'ONLY ' + varints[0].stock + ' LEFT' : '';

        if (varints[0].stock == 0) {
          div.textContent = 'SOLD OUT';
          out_of_stock_text.classList.add('out_of_stock_text_active');
          product_img_div.classList.add('out_of_stock');
          quickAdd.classList.remove('quickAdd_active');
          quickAdd.classList.add('quickAdd_deactive');
        } else {
          out_of_stock_text.classList.remove('out_of_stock_text_active');
          product_img_div.classList.remove('out_of_stock');
          quickAdd.classList.remove('quickAdd_deactive');
          quickAdd.classList.add('quickAdd_active');
        }
      }
    },

    /* change images on hover */
    mouseover(event, imgsrc) {
      event.target.src = imgsrc;
    },
    mouseleave(event, imgsrc) {
      event.target.src = imgsrc;
    },
    /* end change images on hover */

    /* change grid column */
    setScreenRangeGrid() {
      const width = window.innerWidth;
      if (width > 2000) {
        this.gridColumn = 6;
      } else if (width > 767 && width < 2000) {
        this.gridColumn = 4;
      } else {
        this.gridColumn = 2;
      }
    },

    sliderChange(event) {
      if (event.target.value == 2) {
        this.gridMin = false;
        this.gridMax = true;
      } else if (event.target.value == 6) {
        this.gridMin = true;
        this.gridMax = false;
      } else {
        this.gridMin = false;
        this.gridMax = false;
      }
    },
    /* end change grid column */
    /* Clear all filter */
    clearAllFilter() {
      const arrayName = ['category', 'color', 'size', 'material'];
      arrayName.map((item) => {
        this.clearCheckBoxs(item);
      });
      this.showClearAll = false;
    },
    /* End Clear all filter */

    /* start unchecked checkbox when click clear button in dropdown */
    clearCheckBoxs(name) {
      const markedCheckbox = document.getElementsByName(name);
      for (const checkbox of markedCheckbox) {
        if (checkbox.checked) checkbox.checked = false;
      }
      if (name == 'category') {
        this.selected = [];
        this.filterByCategory = [];
      } else if (name == 'color') {
        this.selectedColor = [];
        this.filterByColor = [];
      } else if (name == 'size') {
        this.selectedSize = [];
        this.filterBySize = [];
      } else if (name == 'material') {
        this.selectedMaterial = [];
        this.filterByMaterial = [];
      }
      this.clearAllOption();
    },

    /* clear option that selected in drop down under particular option */
    clearAllOption() {
      if (this.selected.length > 0) {
        this.filterProduct();
      } else if (this.selectedColor.length > 0) {
        this.filterProductByColor();
      } else if (this.selectedSize.length > 0) {
        this.filterProductBySize();
      } else if (this.selectedMaterial.length > 0) {
        this.filterProductByMaterial();
      } else {
        this.showClearAll = false;
        this.productList = this.fullproductList; //this.array_chunk(products, 20);
        const applyCta = document.querySelector('.apply_filter_cta');
        applyCta.setAttribute('disabled', '');
      }
    },

    /* set selected category checkbox value */
    onCheck(event) {
      if (this.selected.includes(event.target.value)) {
        this.selected = this.selected.filter(function (geeks) {
          return geeks != event.target.value;
        });
      } else {
        this.selected.push(event.target.value);
      }
      this.filterProduct();
    },

    /* set selected color checkbox value */
    onCheckColor(event) {
      if (this.selectedColor.includes(event.target.value)) {
        this.selectedColor = this.selectedColor.filter(function (geeks) {
          return geeks != event.target.value;
        });
      } else {
        this.selectedColor.push(event.target.value);
      }
      this.filterProductByColor();
    },

    /* set selected size checkbox value */
    onCheckSize(event) {
      if (this.selectedSize.includes(event.target.value)) {
        this.selectedSize = this.selectedSize.filter(function (geeks) {
          return geeks != event.target.value;
        });
      } else {
        this.selectedSize.push(event.target.value);
      }
      this.filterProductBySize();
    },

    /* set selected material checkbox value */
    onCheckMaterial(event) {
      if (this.selectedMaterial.includes(event.target.value)) {
        this.selectedMaterial = this.selectedMaterial.filter(function (geeks) {
          return geeks != event.target.value;
        });
      } else {
        this.selectedMaterial.push(event.target.value);
      }
      this.filterProductByMaterial();
    },

    /* set selected sort checkbox value */
    onCheckSort(event) {
      let markedCheckbox = document.getElementsByName('sort');

      for (const checkbox of markedCheckbox) {
        this.selectedSort = [];
        if (checkbox.id == event.target.id) {
          if (this.sortObject.id != undefined && this.sortObject.id == event.target.id) {
            checkbox.checked = false;
            this.sortProduct();
            this.sortObject = {};
          } else {
            markedCheckbox = document.getElementById(event.target.id);
            markedCheckbox.checked = true;
            this.sortObject = markedCheckbox;
            this.selectedSort.push(event.target.value);
            this.sortProduct();
          }
        } else {
          checkbox.checked = false;
        }
      }

      // to close responsive menu in mobile
    },

    /* Fill category dropdown from products data */

    getCategoryDropDownList() {
      let array = [];
      products.map((item) => {
        item.tags.map((ca) => {
          array.push(ca);
        });
      });
      const data = [...new Set(array)];
      array = [];
      data.map((item, index) => {
        const obj = { id: item + index, value: item, text: item };
        array.push(obj);
      });
      return array;
    },
    /* End Fill category dropdown from products data */

    /* Fill color dropdown from products data */

    getColorDropDownList() {
      let array = [];
      products.map((item) => {
        item.options[0].values.map((col) => {
          array.push(col);
        });
      });
      const data = [...new Set(array)];
      array = [];
      data.map((item, index) => {
        const obj = { id: item + index, value: item, text: item };
        if (item != null) {
          array.push(obj);
        }
      });
      return array;
    },

    /* End Fill color dropdown from products data */

    /* Fill size dropdown from products data */
    getSizeDropDownList() {
      let array = [];
      products.map((item) => {
        item.variants.map((col) => {
          array.push(col.option2);
        });
      });
      const data = [...new Set(array)];
      array = [];
      data.map((item, index) => {
        const obj = { id: item + index, value: item, text: item };
        if (item != null) {
          array.push(obj);
        }
      });
      return array;
    },
    /* End Fill size dropdown from products data */

    /* Fill material dropdown from products data */
    getMaterialDropDownList() {
      let array = [];
      products.map((item) => {
        item.variants.map((col) => {
          array.push(col.option3);
        });
      });
      const data = [...new Set(array)];
      array = [];
      data.map((item, index) => {
        const obj = { id: item + index, value: item, text: item };
        if (item != null) {
          array.push(obj);
        }
      });
      return array;
    },
    /* End Fill material dropdown from products data */

    /* sort product based on price low to high and vice-verse */
    sortProduct() {
      if (this.selectedSort.length > 0) {
        const obj = this.selectedSort[0];
        this.productList.sort(function (a, b) {
          if (obj == 'LowToHigh') {
            return a.variants[0].price - b.variants[0].price;
          } else if (obj == 'HighToLow') {
            return b.variants[0].price - a.variants[0].price;
          } else if (obj == 'Latest') {
            return new Date(b.created_at) - new Date(a.created_at);
          }
        });
      }
    },

    /* set product in array based on selected category option */
    filterProduct() {
      let array = [];
      if (this.selected.length > 0) {
        // Get Category product after multi select option in dropdown
        this.selected.map((cate) => {
          const filter = products.filter((item) => {
            return item.tags.includes(cate);
          });
          if (array.length > 0) {
            array = new Set([...array, ...filter]);
            array = [...array];
          } else {
            array = filter;
          }
        });
        this.filterByCategory = array;
        array = this.getUniqueRecord(array, 'category');
      } else {
        this.filterByCategory = [];
        this.clearAllOption();
      }
      this.page_index = 0;
    },

    /* set product in array based on selected color option */
    filterProductByColor() {
      let array = [];
      if (this.selectedColor.length > 0) {
        // Get Color product after multi select option in dropdown
        this.selectedColor.map((col) => {
          const filter = products.filter((item) => {
            return item.options[0].values.includes(col);
          });
          if (array.length > 0) {
            array = new Set([...array, ...filter]);
            array = [...array];
          } else {
            array = filter;
          }
        });
        this.filterByColor = array;
        array = this.getUniqueRecord(array, 'color');
      } else {
        this.filterByColor = [];
        this.clearAllOption();
      }
      this.page_index = 0;
    },

    /* set product in array based on selected size option */
    filterProductBySize() {
      let array = [];
      if (this.selectedSize.length > 0) {
        // Get Size product after multi select option in dropdown
        this.selectedSize.map((siz) => {
          const filter = products.filter((item) => {
            return item.variants[0].option2 == siz.toUpperCase();
          });
          if (array.length > 0) {
            array = new Set([...array, ...filter]);
            array = [...array];
          } else {
            array = filter;
          }
        });
        this.filterBySize = array;
        array = this.getUniqueRecord(array, 'size');
      } else {
        this.filterBySize = [];
        this.clearAllOption();
      }
      this.page_index = 0;
    },

    /* set product in array based on selected material option */
    filterProductByMaterial() {
      let array = [];
      if (this.selectedMaterial.length > 0) {
        // Get Material product after multi select
        this.selectedMaterial.map((mat) => {
          const filter = products.filter((item) => {
            return item.variants[0].option3 == mat;
          });
          if (array.length > 0) {
            array = new Set([...array, ...filter]);
            array = [...array];
          } else {
            array = filter;
          }
        });
        this.filterByMaterial = array;
        array = this.getUniqueRecord(array, 'material');
      } else {
        this.filterByMaterial = [];
        this.clearAllOption();
      }
      this.page_index = 0;
    },

    /*satrt filter and unique order after apply filter option */
    getUniqueRecord(array, type) {
      if (this.filterByCategory.length > 0 && type != 'category') {
        array = this.filterArrayToUniqueRecord(array, this.filterByCategory);
      }
      if (this.filterByColor.length > 0 && type != 'color') {
        array = this.filterArrayToUniqueRecord(array, this.filterByColor);
      }
      if (this.filterBySize.length > 0 && type != 'size') {
        array = this.filterArrayToUniqueRecord(array, this.filterBySize);
      }
      if (this.filterByMaterial.length > 0 && type != 'material') {
        array = this.filterArrayToUniqueRecord(array, this.filterByMaterial);
      }
      const applyCta = document.querySelector('.apply_filter_cta');

      if (array.length > 0) {
        applyCta.removeAttribute('disabled');
      }
      this.productList = array; ///this.array_chunk(array, 20);
      this.showClearAll = true;
      this.sortProduct();
      return array;
    },

    filterArrayToUniqueRecord(array, filterWithArray) {
      return filterWithArray.filter((el) => {
        return array.some((f) => {
          return f.id === el.id;
        });
      });
    },
    /*end filter and unique order after apply filter option */

    /* load product on scroll */
    loadMore() {
      this.busy = true;
      window.onscroll = () => {
        const bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (
          this.filterByColor.length == 0 &&
          this.filterBySize.length == 0 &&
          this.filterByCategory.length == 0 &&
          this.filterByMaterial.length == 0
        ) {
          if (bottomOfWindow) {
            const append = products.slice(
              this.productList.length,
              this.productList.length + this.page_size
            );
            this.productList = this.productList.concat(append);
            this.fullproductList = this.productList;
          }
        }
      };
      if (this.productList.length == 0) {
        const append = products.slice(this.productList.length, this.page_size);
        this.productList = this.productList.concat(append);
        this.fullproductList = this.productList;
      }

      this.busy = false;
    },

    addToCard() {
      // console.log(product);
    },

    /* On click page number change page */
    // paginate: function (index) {
    //     this.page_index = index;
    //     this.sortProduct();
    //     window.scrollTo({ top: 0, behavior: "smooth" });

    // },

    /* this function is used to set 20 record on single page */
    // array_chunk: function (array, size) {
    //     const chunked_arr = [];
    //     let index = 0;
    //     while (index < array.length) {
    //         chunked_arr.push(array.slice(index, size + index));
    //         index += size;
    //     }

    //     return chunked_arr;
    // },
  },
};
</script>

<style>
/* .nav-dots .swiper-button-prev{
    position: static;
} */
.nav-dots .swiper-button-prev::after {
  /* content: url(https://cdn.shopify.com/s/files/1/0577/1178/8125/files/color-swatches-arrow.svg?v=1653549630);
    position: static; */
  display: none !important;
}
.nav-dots .swiper-button-next::after {
  content: url(https://cdn.shopify.com/s/files/1/0577/1178/8125/files/color-swatches-arrow.svg?v=1653549630);
}
.nav-dots .swiper.swiper-initialized {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 0;
}
.nav-dots .swiper-button-next {
  position: static;
}

@media (max-width: 767px) {
  .grid_inner .product_item:nth-child(5n) {
    grid-column: 1 / span 2;
  }
}
</style>

<style scoped>
/* ETHICS IN FASHION CSS START */
.ethics_in_fashion {
  padding: 60px 0;
  border-top: 1px solid #000;
}
.ethics_content_inner .body_text,
.ethics_content_inner .sec_heading {
  text-align: center;
}
.ethics_content_inner .body_text {
  margin-bottom: 50px;
}
.fashion_img_grid {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: center;
}
.fashion_img_grid img {
  width: 55px;
}
.apply_filter_cta_wrapper {
  display: none;
}
/* ETHICS IN FASHION CSS END */

/* common css */
/* * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
} */

body {
  margin: 0px !important;
}
.vue-logo-back {
  background-color: black;
}

img {
  max-width: 100%;
}

.pt-6 {
  padding-top: 1.5rem;
}

.flex {
  display: flex;
}

button {
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: none;
}

button:focus {
  outline: none;
}

ul {
  list-style: none;
  width: 100%;
  text-align: center;
  justify-content: center;
}

.card-title {
  font-size: 14px;
  text-align: left;
}

.card .card-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  margin-top: 6px;
}

.card-title.bold {
  font-weight: 700;
}

.filter-option {
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  z-index: 9;
}

.col {
  flex: 0 0 50%;
  max-width: 50%;
  padding-left: 1rem;
  padding-right: 1rem;
}

label {
  margin: 0;
}

/***** MultiSelect *****/

.dropdown {
  position: relative;
  cursor: pointer;
}

.multiselect {
  position: relative;
}

.sortFilter .multiselect .tmb_header_dopdown {
  right: 0;
  left: auto;
}

.multiselect .tmb_header_dopdown {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-top: 0;
  border-radius: 0 0 3px 3px;
  left: 0px;
  padding: 20px;
  position: absolute;
  top: 30px;
  width: 100%;
  list-style: none;
  min-width: 260px;
  margin: 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}

.multiselect ul {
  overflow-y: scroll;
  max-height: 250px;
  padding: 10px 0;
  overscroll-behavior: none;
}

.multiselect.active .tmb_header_dopdown {
  top: 0px;
  opacity: 1;
  visibility: visible;
}

.multiselect.active .btn_wrapper {
  opacity: 1;
  visibility: visible;
  padding-top: 10px;
}

.multiselect .btn_wrapper {
  opacity: 0;
  visibility: hidden;
}
.multiselect ul::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.multiselect ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(223, 223, 223);
  border-radius: 10px;
}

/* Handle */
.multiselect ul::-webkit-scrollbar-thumb {
  background: rgb(155, 152, 152);
  border-radius: 10px;
}

/* .multiselect ul::-webkit-scrollbar {
    display: none;
} */

.sort_by_inner .multiselect ul {
  left: -204px;
}
.overselect {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.c-form-input {
  background: transparent;
  border: none;
  outline: none;
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  padding-right: 12px;
}

select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

.multiselect > .tmb_header_dopdown > ul > li {
  display: flex;
  align-items: center;
  gap: 5px;
}

.multiselect > .tmb_header_dopdown > ul > li:not(:last-child) {
  margin-bottom: 19px;
}

.multiselectOption {
  width: 14px;
  height: 14px;
  display: none;
}

.optionLabel {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: #000000;
  position: relative;
  padding-left: 22px;
  cursor: pointer;
  text-align: start;
  text-transform: capitalize;
}

.optionLabel::after {
  position: absolute;
  content: '';
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 14px;
  height: 14px;
  background: #fff;
  border: 1px solid #000;
}

.multiselectOption:checked + label::after {
  background: #000;
}

.btn_wrapper {
  display: flex;
  align-items: center;
  gap: 1px;
  width: 100%;
}

.filterBtn {
  background: #ffffff;
  border: 1px solid #000000;
  padding: 4px 15px;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  width: 100%;
  cursor: pointer;
  transition: 0.3s;
}
.multiselect .filterBtn:hover {
  background: #000;
  border: 1px solid transparent;
  color: #fff;
}

.filterBtn.modifier {
  background: #000;
  color: #fff;
}

.clearFilter {
  background: #000000;
  padding: 6px;
  max-width: 94px;
  width: 100%;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  justify-content: center;
  color: #ffffff;
  gap: 4px;
  cursor: pointer;
  visibility: hidden;
}

.clearFilter.activeClear {
  visibility: visible;
}

.filter_row {
  padding: 0 15px;
  margin: 115px 0 12px;
  position: sticky;
  top: 0;
  z-index: 4;
}

.filters_inner,
.row_inner {
  display: flex;
  align-items: center;
  gap: 45px;
}

.row_inner {
  gap: 15px;
  justify-content: space-between;
  align-items: center;
  background: #ffff;
  padding: 10px 0;
}

.sortBtn {
  background: transparent;
  padding: 0;
  color: #000;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  gap: 5px;
  align-items: center;
  letter-spacing: 0.02em;
}

.product_grid {
  padding: 0 15px 103px;
}

.grid_inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 6px;
  row-gap: 28px;
}

.grid_inner_max {
  grid-template-columns: repeat(6, 1fr) !important;
  transition: 0.3s;
}

.grid_inner_min {
  grid-template-columns: repeat(2, 1fr) !important;
  transition: 0.3s;
}

.grid_inner .card {
  border: none;
}

.card > img {
  width: 100%;
  height: 100%;
}

.responsiveFilter {
  display: none;
}

.sort_by_inner {
  display: flex;
  align-items: center;
  gap: clamp(20px, 11vw, 150px);
}

.progress {
  background: #252525;
  border-radius: 8px;
  height: 1px;
  width: 134px;
  outline: none;
  transition: background 450ms ease-in;
  appearance: none;
  -webkit-appearance: none;
}

.progress::-webkit-slider-thumb {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-appearance: none;
  cursor: ew-resize;
  background: #252525;
}

.add_remove {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.add_remove button {
  line-height: 0;
}
.nav-dots span {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: scroll;
  width: 100px;
}
.nav-dots span::-webkit-scrollbar {
  display: none;
}

.pt-6 li {
  padding: 10px;
}

.p-2 {
  text-decoration: none;
}

.pageactive .p-2 {
  border-bottom: solid 3px #25a26b;
}

.productnotfound {
  display: block;
  padding: 10%;
  text-align: center;
}

.productfound {
  display: none;
}

.centeralign.addmargin .body_text {
  padding: 20px 0;
}

.quickAdd {
  border: 1px solid #000;
  padding: 8px 30px;
  background: #ffffff;
  gap: 15px;
  flex-direction: row;
  align-items: flex-start;
  transition: 0.3s;
  display: none;
}
.quickButton .quickAdd:hover {
  background: #000;
}
.quickButton .quickAdd:hover span {
  color: #fff;
}
.quickAdd_deactive {
  visibility: hidden;
}
.quickAdd_active {
  visibility: visible;
}
.quickAdd span {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.quickButton {
  justify-content: space-between;
  display: flex;
  opacity: 0;
  visibility: hidden;
  align-items: center;
  transition: 0.3s;
  position: relative;
  z-index: -1;
}
.quickActive {
  opacity: 1;
  visibility: visible;
}

.quickButton ul {
  text-align: left;
  /* width: 50%; */
}
.quickButton .product_cta_wrapper {
  width: 50%;
  text-align: end;
  display: none;
}

.nav-dots {
  /* width: 100%; */
  /* bottom: 9px; */
  /* height: 11px; */
  display: block;
  /* padding: 15px 0px; */
}

.nav-dots .nav-dot {
  top: 0px;
  min-width: 13px;
  height: 13px;
  margin: 0 6px;
  position: relative;
  border-radius: 100%;
  display: inline-block;
  background: red;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: 0.3s;
}

/* .nav-dots .nav-dot:hover {
  background-color: rgba(0, 0, 0, 0.8);
} */

input#img-1:checked ~ .nav-dots label#img-dot-1,
input#img-2:checked ~ .nav-dots label#img-dot-2,
input#img-3:checked ~ .nav-dots label#img-dot-3,
input#img-4:checked ~ .nav-dots label#img-dot-4,
input#img-5:checked ~ .nav-dots label#img-dot-5,
input#img-6:checked ~ .nav-dots label#img-dot-6 {
  background: rgba(0, 0, 0, 0.8);
}
.red {
  background: red;
}
.black {
  background: black;
}
.AZURE {
  background: #007fff;
}
.product-form__color-swatch {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  margin: 4px;
}
.item_left {
  text-align: end;
  height: 12px;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 12px;
  align-items: center;
  letter-spacing: 0.02em;

  color: #878787;
  visibility: hidden;
}
.out_of_stock img {
  opacity: 0.2;
}
.item_left_active {
  visibility: visible !important;
}
.product_img_wrapper {
  position: relative;
}
.out_of_stock_text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  align-items: center;
  letter-spacing: 0.02em;
  color: red;
  transform: translate(-50%, -50%);
  visibility: hidden;
}
.out_of_stock_text_active {
  visibility: visible !important ;
}
.color_swatches {
  position: relative;
}
.arrow_icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -11px;
  line-height: 0;
  cursor: pointer;
}

/* RSPONSIVE FILTER BTNS CSS START */
.filter_responsive {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 4;
  display: none;
}
.filter_responsive .filter_cta_wrapper {
  display: flex;
  align-items: center;
  gap: 2px;
}
.filter_cta {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #000000;
  background: #e9e7e3;
  border: 1px solid #000000;
  width: 100%;
  padding: 14px;
}
.filters_responsive {
  display: none;
}
/* RSPONSIVE FILTER BTNS CSS END*/
.activecolor {
  border: 1px solid #878787 !important;
}
.product_img_wrapper img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}

@media (min-width: 768px) {
  .filter .overselect svg,
  .sortFilter svg {
    transition: 0.3s;
  }
  .filter:hover .overselect svg,
  .sortFilter:hover svg {
    transform: rotate(180deg);
  }
}
/* RESPONSIVE BREAKPOINTS START */
@media (max-width: 1440px) {
  .product_img_wrapper img {
    height: 348px;
    max-width: 348px;
  }
}
@media (max-width: 1200px) {
  .product_img_wrapper img {
    height: auto;
    max-width: 348px;
  }
  .quickAdd[data-v-bb57343a] {
    padding: 8px 20px;
  }
}
@media (max-width: 1024px) {
  .out_of_stock_text {
    font-size: 14px;
  }
  .grid_inner {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 991px) {
  .progress {
    width: 105px;
  }
}
@media (max-width: 767px) {
  .product_img_wrapper img {
    height: auto;
    max-width: 100%;
    width: 100%;
  }
  .filter_row {
    margin: 18px 0 0px;
    z-index: 5;
  }
  .product_cta_wrapper {
    display: none;
  }
  .grid_inner {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2px;
    row-gap: 11px;
  }
  .card-title {
    font-size: 12px;
    margin: 10px 0 0;
  }
  .product_grid,
  .filter_row {
    padding: 0 2px;
  }
  .product_grid {
    padding-bottom: 80px;
  }
  .filter {
    width: 100%;
  }
  .dropdown {
    display: flex;
    align-items: center;
    width: 100%;

    background: #e9e7e3;
  }
  .overselect svg {
    position: absolute;
    top: 50%;
    right: 0;
    transition: 0.3s;
    transform: translateY(-50%);
  }
  .dropdown.active .overselect svg {
    transform: translateY(-50%) rotate(180deg);
  }
  .filters_responsive {
    display: block;
    z-index: 4;
  }
  .filters,
  .sort_by {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #e9e7e3;
    padding: 11px;
    height: calc(100% - 58px);
    z-index: 9;
    transition: 0.3s;
    overflow-y: scroll;
  }
  /* .qwe{
        height: 380px;
    } */
  .sort_by {
    height: 100%;
    min-height: 100vh;
    transform: translateX(110%);
  }
  .filters {
    transform: translateX(-110%);
  }
  .filters.show,
  .sort_by.show {
    transform: translateX(0);
  }
  .filters_inner {
    flex-direction: column;
    gap: 0;
    margin-top: 45px;
  }
  .filter_responsive {
    display: inline-block;
    margin-top: 13px;
  }
  .row_inner {
    flex-direction: column;
    overflow: hidden;
    position: relative;
    padding: 0;
  }
  .filters .filter_cta_wrapper {
    display: flex;
    gap: 2px;
    width: calc(100% + 18px);
    margin-left: -9px;
  }

  .filters .filter_cta_wrapper .filter-modifier {
    border: none;
  }

  .filters .multiselect ul {
    padding: 10px 0 40px;
  }
  .filters .filter_cta_wrapper .clear-modifier {
    background-color: #000000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
  }
  .filters .filter_cta_wrapper .clear-modifier.activeClear {
    opacity: 1;
    visibility: visible;
  }
  .filters .filter_cta_wrapper .clear-modifier svg {
    width: 10px;
    height: 10px;
    margin-top: -2px;
  }
  .c-form-input {
    font-size: 18px;
    line-height: 21px;
    padding-right: 0;
  }
  .multiselect .tmb_header_dopdown {
    position: static !important;
    height: 0;
    overflow: hidden;
    background: #e9e7e3;
    box-shadow: none;
    display: inline-block;
  }
  .tmb_header_dopdown .btn_wrapper {
    display: none;
  }
  .optionLabel {
    font-size: 18px;
    line-height: 21px;
    padding-left: 35px;
  }
  .filter .optionLabel {
    padding-left: 30px;
  }
  .filter .multiselect .tmb_header_dopdown {
    padding: 10px 14px 0;
  }
  .filter .multiselect.active .tmb_header_dopdown {
    min-height: 250px;
    /* overflow: visible; */
  }
  .filters_inner .clearFilter {
    display: none;
  }
  .multiselect {
    height: 0;
    overflow: hidden;
    transition: 0.3s;
  }
  .multiselect.active {
    height: 250px;
    overflow: visible;
  }
  .range,
  .sortBtn {
    display: none;
  }
  .sortFilter {
    width: 100%;
  }
  .sort_by .filter-modifier {
    border: none;
    width: 50%;
  }
  .sort_by .filter_cta_wrapper {
    text-align: end;
  }
  .sort_by .multiselect,
  .sort_by .multiselect .tmb_header_dopdown {
    top: 0px;
    opacity: 1;
    visibility: visible;
    height: 250px;
    overflow: visible;
  }
  .sort_by .multiselect ul {
    overflow: unset;
    height: auto;
    max-height: unset;
  }
  .sort_by .tmb_header_dopdown {
    padding: 0;
  }
  .sort_by .multiselect li {
    margin: 0 !important;
    padding: 14px 0 14px 9px;
    border-bottom: 1px solid #000;
  }
  .nav-dots {
    margin-top: 9px;
  }
  .ethics_in_fashion {
    padding: 30px 0 60px;
  }
  .fashion_img_grid {
    gap: 20px;
  }
  .fashion_img_grid img {
    width: 38px;
  }
  .ethics_content_inner .body_text,
  .ethics_content_inner .sec_heading {
    text-align: start;
    padding: 0 12px;
  }
  .filters_inner .filter {
    border-bottom: 1px solid #000;
    padding: 13px 0 13px 9px;
    position: relative;
    overflow: hidden;
  }
  .filters_inner .filter:last-child {
    border-bottom: none;
  }
  .apply_filter_cta_wrapper {
    display: block;
    background: #e9e7e3;
    padding: 11px;
    position: fixed;
    left: 0;
    bottom: 0px;
    transform: translateX(-110%);
    z-index: 99;
    transition: 0.3s;
    width: 100%;
    text-align: center;
  }
  .apply_filter_cta_wrapper.show {
    left: 50%;
    transform: translateX(-50%);
  }
  .apply_filter_cta {
    background: #000000;
    border: 1px solid #000000;
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #ffffff;
    padding: 13px;
    transition: 0.3s;
  }
  .multiselect ul {
    overscroll-behavior: unset;
  }
  .filters_inner_row {
    height: 80vh;
    margin-bottom: 45px;
  }
  .apply_filter_cta[disabled] {
    opacity: 0;
    visibility: hidden;
  }
  .color-filter ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }
}
</style>
